import { ButtonUp } from '../shared/ui/ButtonUp/ButtonUp';
import './styles/index.scss';
import Whatsapp from '../widgets/WhatsApp/WhatsApp';
import Navbar from '../feature/Navbar/Navbar';
import { 
    Routes, 
    Route, 
}
    from "react-router-dom";

import { MainPage } from '../pages/MainPage/MainPage';
import { HygienePage } from '../pages/HygienePage/ui/HygienePage';
import { EndodonticsPage } from '../pages/EndodonticsPage/EndodonticsPage';
import { ProstheticsPage } from '../pages/ProstheticsPage/ProstheticsPage';
import { ImplantPage } from '../pages/ImplantPage/ImplantPage';
import { AboutPage } from '../pages/AboutPage/AboutPage';
import { ContactPage } from '../pages/ContactPage/ContactPage';
import PersonalDataPage from '../pages/PersonalDataPage/PersonalDataPage';
import { ScrollToTop } from '../shared/hooks/scrollToTop';
import PlanPage from '../pages/PlanPage/PlanPage';


function App() {
  return (
<div>
        <ScrollToTop/>
        <Navbar/>   

        <Routes>
            <Route path='/' element = {<MainPage/>}/>
            <Route path='/hygiene' element = {<HygienePage/>}/>
            <Route path='/endodontics' element = {<EndodonticsPage/>}/>
            <Route path='/prosthetics' element = {<ProstheticsPage/>}/>
            <Route path='/implant' element = {<ImplantPage/>}/>
            <Route path='/about' element = {<AboutPage/>}/>
            <Route path='/contact' element = {<ContactPage/>}/>
            <Route path='/personal' element = {<PersonalDataPage/>}/>
            <Route path='/plan' element = {<PlanPage/>}/>
          </Routes>

        <Whatsapp/>
        <ButtonUp/>
      
</div>
  );
}

export default App;
